// extracted by mini-css-extract-plugin
export default {"header":"Header_header__HXQOm","walletStatus":"Header_walletStatus__MN4bR","connected":"Header_connected__RDRd9","tokenDisplay":"Header_tokenDisplay__j88XG"};